export default __webpack_public_path__ + "static/100--stacked-column-2355345619dfe52a4235cc5ed6593345.png";